import React from 'react'
import { Text } from 'rebass'

const FAQ = ({ children }) => (
    <Text mt={1} fontSize={[1, 2]}>
        {children}
    </Text>
)
export default FAQ
